import { allProducts, siteConfig } from "./products";

// Live catalog = static products + admin-published products from the backend.
// Components read these during render; App passes an onChange tick so each dataset re-renders as soon as it arrives.
export const liveProducts = [...allProducts];
export const liveReels = ["/assets/reel-1.mp4", "/assets/reel-2.mp4", "/assets/reel-3.mp4"];
export const liveCovers = {};
export const liveAnnouncement = { enabled: false, text: "" };
export const liveReviews = [...siteConfig.reviews];
export const liveSettings = { cod: false };

export async function loadLiveData(apiUrl, onChange) {
  const notify = () => { if (onChange) onChange(); };
  const loadProducts = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/products`);
      const data = await res.json();
      let changed = false;
      (Array.isArray(data) ? data : []).forEach((p) => {
        const i = liveProducts.findIndex((x) => x.id === p.id);
        if (i === -1) { liveProducts.push(p); changed = true; }
        else { liveProducts[i] = p; changed = true; }
      });
      // drop admin-deleted products
      for (let i = liveProducts.length - 1; i >= 0; i -= 1) {
        const p = liveProducts[i];
        if (!allProducts.find((x) => x.id === p.id) && !data.find((x) => x.id === p.id)) {
          liveProducts.splice(i, 1);
          changed = true;
        }
      }
      if (changed) notify();
    } catch { /* backend unreachable — static catalog still works */ }
  };
  const loadCovers = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/collection-covers`);
      const data = await res.json();
      let changed = false;
      Object.entries(data || {}).forEach(([name, url]) => {
        if (liveCovers[name] !== url) { liveCovers[name] = url; changed = true; }
      });
      if (changed) notify();
    } catch { /* keep default card images */ }
  };
  const loadReels = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/reels`);
      const urls = await res.json();
      let changed = false;
      (Array.isArray(urls) ? urls : []).forEach((u) => {
        if (!liveReels.includes(u)) { liveReels.push(u); changed = true; }
      });
      for (let i = liveReels.length - 1; i >= 0; i -= 1) {
        const r = liveReels[i];
        if (!r.startsWith("/assets/") && !urls.includes(r)) { liveReels.splice(i, 1); changed = true; }
      }
      if (changed) notify();
    } catch { /* keep static reels */ }
  };
  const loadAnnouncement = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/announcement`);
      const data = await res.json();
      const next = { enabled: !!data.enabled, text: data.text || "" };
      if (liveAnnouncement.enabled !== next.enabled || liveAnnouncement.text !== next.text) {
        liveAnnouncement.enabled = next.enabled;
        liveAnnouncement.text = next.text;
        notify();
      }
    } catch { /* banner hidden by default */ }
  };
  const loadReviews = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/reviews`);
      const data = await res.json();
      const next = [...siteConfig.reviews, ...(Array.isArray(data) ? data : [])];
      if (JSON.stringify(next) !== JSON.stringify(liveReviews)) {
        liveReviews.splice(0, liveReviews.length, ...next);
        notify();
      }
    } catch { /* static reviews remain */ }
  };
  const loadSettings = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/settings`);
      const data = await res.json();
      if (liveSettings.cod !== !!data.cod) { liveSettings.cod = !!data.cod; notify(); }
    } catch { /* COD stays off */ }
  };
  await Promise.all([loadProducts(), loadCovers(), loadReels(), loadAnnouncement(), loadReviews(), loadSettings()]);
}
